import React, { useContext } from "react";
import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";

interface SVGProps extends React.SVGProps<SVGSVGElement> {
  isActive?: boolean;
  fill?: string;
}

const ActiveBillingHistoryIcon: React.FC<SVGProps> = ({ isActive = false, fill, ...props }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = fill?.trim() ? fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";

  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={isActive ? "url(#filter0_dddd_30500_50335)" : undefined}>
        <path
          d="M12.8211 22.9996C12.4299 22.9996 12.0392 22.8963 11.6908 22.6902L3.95901 18.1166C3.65598 17.9376 3.55198 17.5406 3.72725 17.2301C3.90199 16.9196 4.28948 16.8136 4.5925 16.9927L12.3243 21.5663C12.6305 21.7475 13.0117 21.7475 13.3179 21.5663L20.2362 17.474C20.5424 17.2928 20.7329 16.9548 20.7329 16.5924V8.40735C20.7329 8.04496 20.5424 7.70692 20.2362 7.52572L13.3179 3.43293C13.0111 3.25173 12.6305 3.25173 12.3243 3.43293L5.40602 7.52572C5.09983 7.70692 4.90925 8.04496 4.90925 8.40735V12.9323C4.90925 13.2909 4.62576 13.5814 4.27575 13.5814C3.92575 13.5814 3.64226 13.2909 3.64226 12.9323V8.40735C3.64226 7.58252 4.07515 6.81393 4.77252 6.40179L11.6908 2.30899C12.3882 1.89684 13.254 1.89684 13.9514 2.30899L20.8697 6.40125C21.567 6.81339 21.9999 7.58197 21.9999 8.40681V16.5919C21.9999 17.4167 21.567 18.1853 20.8697 18.5974L13.9514 22.6897C13.6029 22.8958 13.2117 22.9991 12.8211 22.9991V22.9996Z"
          fill={finalColor}
        />
        <path
          d="M4.2758 10.493H6.16573C6.46242 10.493 6.64772 10.7711 6.49937 10.9934L5.55441 12.4099L4.60944 13.8265C4.4611 14.0488 4.0905 14.0488 3.94216 13.8265L2.99719 12.4099L2.05223 10.9934C1.90389 10.7711 2.08918 10.493 2.38587 10.493H4.2758Z"
          fill={finalColor}
        />
        <path
          d="M15.4628 14.2126C15.4628 14.5696 15.4011 14.8914 15.2775 15.1781C15.154 15.4647 14.9787 15.7119 14.7517 15.9191C14.5247 16.1268 14.2513 16.2928 13.9308 16.4172C13.6104 16.5416 13.2556 16.6206 12.8666 16.6541L12.7388 17.9874C12.7346 18.0204 12.7256 18.0496 12.7114 18.0745C12.6971 18.0993 12.6707 18.1204 12.6322 18.1367C12.5936 18.1529 12.5408 18.167 12.4743 18.1772C12.4073 18.1875 12.3233 18.1929 12.222 18.1929C12.0921 18.1929 11.9881 18.1864 11.9089 18.1745C11.8297 18.1621 11.768 18.1442 11.7236 18.1215C11.6788 18.0988 11.6497 18.0685 11.6355 18.0312C11.6212 17.9939 11.618 17.9522 11.6265 17.9068L11.7542 16.6422C11.58 16.6173 11.4159 16.5849 11.2617 16.5454C11.1076 16.5059 10.9677 16.4627 10.842 16.4145C10.7164 16.3669 10.6081 16.3177 10.5168 16.2679C10.4255 16.2182 10.3569 16.1695 10.3099 16.1214C10.2634 16.0738 10.2296 16.0029 10.2096 15.9093C10.189 15.8158 10.179 15.6778 10.179 15.495C10.179 15.3539 10.1832 15.2376 10.1911 15.1462C10.199 15.0548 10.2133 14.9839 10.2339 14.9341C10.2539 14.8844 10.2793 14.8503 10.3099 14.8314C10.3405 14.813 10.3759 14.8033 10.416 14.8033C10.4688 14.8033 10.5459 14.8346 10.6472 14.8968C10.7486 14.959 10.8784 15.0277 11.0363 15.1024C11.1941 15.177 11.3858 15.2457 11.6107 15.3079C11.8355 15.3701 12.1 15.4015 12.4041 15.4015C12.8782 15.4015 13.2308 15.3111 13.462 15.1305C13.6933 14.9498 13.8084 14.7102 13.8084 14.4111C13.8084 14.2115 13.7587 14.0477 13.6595 13.9189C13.5602 13.7902 13.4272 13.6772 13.2614 13.5793C13.0951 13.4819 12.9077 13.3943 12.6992 13.3175C12.4902 13.2407 12.2764 13.1585 12.0578 13.0714C11.8387 12.9843 11.6249 12.8826 11.4164 12.7663C11.2073 12.65 11.0199 12.5067 10.8542 12.3363C10.6879 12.166 10.5554 11.9593 10.4561 11.7165C10.3569 11.4736 10.3072 11.1799 10.3072 10.8349C10.3072 10.5233 10.3579 10.2399 10.4593 9.9846C10.5606 9.72931 10.7063 9.50593 10.8969 9.315C11.0875 9.12407 11.3214 8.96938 11.599 8.85093C11.8767 8.73248 12.1919 8.65243 12.5445 8.61132L12.666 7.3592C12.6702 7.3262 12.6792 7.29808 12.6934 7.27536C12.7077 7.25265 12.7341 7.23155 12.7726 7.21316C12.8111 7.19423 12.8629 7.18125 12.9278 7.1726C12.9927 7.16448 13.0777 7.16016 13.1833 7.16016C13.309 7.16016 13.4135 7.16665 13.4964 7.17909C13.5792 7.19153 13.6431 7.20938 13.688 7.23209C13.7323 7.25481 13.7608 7.2851 13.773 7.32242C13.7851 7.35974 13.7915 7.40139 13.7915 7.44682L13.67 8.6243C13.7835 8.64107 13.9029 8.66379 14.029 8.69299C14.1547 8.7222 14.2724 8.75628 14.3817 8.79576C14.491 8.83524 14.5902 8.87689 14.6794 8.92016C14.7686 8.96343 14.8304 9.00346 14.8647 9.03861C14.899 9.07377 14.9254 9.10947 14.9439 9.14463C14.9619 9.17978 14.9761 9.22359 14.9867 9.27552C14.9967 9.32744 15.0041 9.38964 15.0078 9.46212C15.012 9.5346 15.0141 9.61897 15.0141 9.71417C15.0141 9.84289 15.0109 9.94891 15.0051 10.0322C14.9993 10.1155 14.9877 10.1788 14.9719 10.222C14.9555 10.2659 14.9376 10.2945 14.917 10.3091C14.8964 10.3237 14.8721 10.3308 14.8441 10.3308C14.7913 10.3308 14.7143 10.3037 14.6129 10.2496C14.5115 10.1955 14.387 10.1377 14.2391 10.0755C14.0913 10.0133 13.9208 9.95486 13.7286 9.90131C13.536 9.84722 13.3243 9.82018 13.093 9.82018C12.8824 9.82018 12.7019 9.84127 12.5519 9.88238C12.402 9.92403 12.2801 9.9819 12.1871 10.0565C12.0937 10.1312 12.0251 10.221 11.9802 10.3243C11.9353 10.4281 11.9132 10.5422 11.9132 10.6672C11.9132 10.8624 11.9638 11.0263 12.0652 11.1594C12.1665 11.2924 12.3012 11.4066 12.4696 11.5018C12.638 11.5975 12.8286 11.6846 13.0413 11.7635C13.2541 11.8425 13.471 11.9253 13.6917 12.0129C13.9124 12.1 14.1293 12.2011 14.3421 12.3152C14.5548 12.4294 14.7444 12.5705 14.9106 12.7387C15.0769 12.9069 15.2105 13.1103 15.3119 13.3494C15.4132 13.5885 15.4639 13.8757 15.4639 14.2121L15.4628 14.2126Z"
          fill={finalColor}
        />
      </g>
      <defs>
        <filter
          id="filter0_dddd_30500_50335"
          x="0"
          y="-0.00012207"
          width="24"
          height="24.9998"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_30500_50335" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_30500_50335"
            result="effect2_dropShadow_30500_50335"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_30500_50335"
            result="effect3_dropShadow_30500_50335"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.670588 0 0 0 0 0.952941 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_30500_50335"
            result="effect4_dropShadow_30500_50335"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect4_dropShadow_30500_50335"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ActiveBillingHistoryIcon;
